/**
 * Reads the first item of a WordPress REST pages array as modal copy.
 * Shared by the app (webpack) and SSR (`require`).
 *
 * @param {Array<{ title?: { rendered?: string }, content?: { rendered?: string } }>} data
 * @returns {{ title: string, content: string }|undefined}
 */
function parseWpPage(data) {
    const page = data && data[0];

    if (!page) {
        return undefined;
    }

    return {
        title: page.title.rendered,
        content: page.content.rendered,
    };
}

module.exports = parseWpPage;
